import { render, staticRenderFns } from "./VueWeatherWidget.vue?vue&type=template&id=31f15fec"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../examples/vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports